import React from 'react';
import { Badge } from '../ui/badge';
import { GALLERY_IMAGES } from '../../config/constants';

const Gallery = () => {
  return (
    <section id="gallery" className="py-20 px-4 bg-black" data-testid="gallery-section">
      <div className="container mx-auto max-w-6xl">
        <div className="text-center mb-16">
          <Badge className="bg-amber-500 text-black mb-4 px-4 py-1 text-sm">GALLERIA</Badge>
          <h2 className="text-4xl md:text-5xl font-serif font-bold mb-4">
            Il nostro <span className="text-amber-500">Gentleman Club</span>
          </h2>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
          {GALLERY_IMAGES.map((image, index) => (
            <div 
              key={index} 
              className="relative overflow-hidden group cursor-pointer aspect-square"
              data-testid={`gallery-image-${index}`}
            >
              <img 
                src={image} 
                alt={`Roger's Club Barberia - Foto ${index + 1}`} 
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
              />
              <div className="absolute inset-0 bg-black/50 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center">
                <div className="text-amber-500 text-sm font-semibold">VISUALIZZA</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Gallery;
